export { default } from './CardContent';